// Module
var code = "<div class=\"modal-body\">\n  <label translate>{{ prompt }}</label>\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" (click)=\"ok()\" translate>OK</button>\n  <button class=\"btn btn-danger ms-2\" (click)=\"cancel()\" translate>Cancel</button>\n</div>\n";
// Exports
module.exports = code;